import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppService} from "../../services/app.service";
import {Observable} from "rxjs";
import {ProfileService} from "../../services/profile.service";
import {AppState} from "../../store/store";
import {Store} from "@ngrx/store";
import {selectProfileAvatar} from "../../store/profile/profile.selectors";

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit, OnDestroy {
  public readonly defaultAvatar: string = this._profileS.defaultAvatar;

  public readonly profileAvatar$: Observable<string> = this._store.select(selectProfileAvatar);

  constructor(
    private readonly _profileS: ProfileService,
    protected readonly appS: AppService,
    private readonly _store: Store<AppState>
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

}
